import { alpha, styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const TemplateBar = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: alpha(theme.palette.error.main, 0.25),
  padding: theme.spacing(2),
  fontStyle: 'italic',
}));

export const FabTitle = styled('span')(({ theme }) => ({
  marginLeft: theme.spacing(2),
  flex: 1,
}));

export const FabIcon = styled(AddIcon)(({ theme }) => ({
  marginRight: theme.spacing(1),
  height: '21px',
}));

export const FabContent = styled('div')({
  maxWidth: '100%',
  height: '100%',
});

export const FabBtn = styled(Button)(({ theme }) => ({
  marginLeft: 'auto',
  marginRight: theme.spacing(1),
}));
